import React, { useEffect, useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import ApiService from "../../services/ApiService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { callAlert } from "../../services/CommonService";
import { handleEncrypt } from "../../services/CryptoService";
function AccountSecurity({ setProfileView }) {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [userDetails, setUserDetails] = useState(false);
  const [loader, setLoader] = useState(false);

  let errorsObj = {};
  const [errors, setErrors] = useState(errorsObj);

  const passwordRegex =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  function validatePassword(password) {
    return passwordRegex.test(password);
  }

  useEffect(() => {
    if (window.location.toString().includes("user")) {
      let userDetailss = localStorage.getItem("userDetails");
      if (userDetailss) {
        setUserDetails(JSON.parse(userDetailss));
      }
    }
  }, []);

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmShowPassword] = useState(false);

  const handleInputChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  // const togglePasswordVisibility = () => {
  //   setIsPasswordVisible(!isPasswordVisible);
  // };

  // const handleCheckboxChange = () => {
  //   setIsPasswordVisible(!isPasswordVisible);
  // };

  const validatePasswordConfirm = () => {
    if (formData.newPassword === formData.confirmPassword) return true;
    else return false;
  };

  const updatePassword = (e) => {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };

    if (formData.currentPassword === "") {
      errorObj.currentPassword = "Please enter current password";
      error = true;
    }
    if (formData.newPassword === "") {
      errorObj.password = "Please enter password";
      error = true;
    } else if (formData.currentPassword === formData.newPassword) {
      errorObj.newPassword = "New passwords can't be same";
      error = true;
    }
    if (formData.confirmpassword === "") {
      errorObj.confirmpassword = "Please enter confirm password";
      error = true;
    } else if (formData.password !== formData.confirmpassword) {
      errorObj.confirmpassword = "Confirm passwords don't match";
      error = true;
    }

    if (!validatePassword(formData.newPassword)) {
      errorObj.password +=
        " Password must contain at least 8 characters, including at least one uppercase letter, one digit, and one special character (@$!%*?&)";
      error = true;
    }
    setErrors(errorObj);
    if (error) return;
    setLoader(true);

    ApiService.postRequest(
      "/users/changepassword",
      {
        password: handleEncrypt(formData.currentPassword),
        newpassword: handleEncrypt(formData.newPassword),
      },
      true
    ).then((response) => {
      setLoader(false);
      if (response.data?.resultCode != 1) {
        callAlert("", response.data.message);
        return;
      }
      if (response.data?.resultCode === 1) {
        callAlert("", response.data.message, "success");
        resetFormData();
        return;
      }
      console.log(response.data.data);
    });
  };

  const resetFormData = () => {
    setFormData({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
    setProfileView("profile");
  };

  return (
    <>
      {/* <p className="text-center fw-bold">Edit your account settings and change your password here.</p> */}
      <div className="p-3 mx-2">
        <div className="form-group mb-3">
          <label htmlFor="email" className="form-label fw-bold">
            Registered Email:
          </label>
          <input
            type="text"
            className="form-control"
            id="userName"
            name="usrName"
            value={userDetails.email}
            disabled={true}
          />
        </div>
        <form onSubmit={updatePassword}>
          <div className="form-group mb-3 position-relative">
            <label htmlFor="currentPassword" className="form-label fw-bold">
              Current Password
            </label>
            <div className="d-flex  align-items-center">
              <input
                type={isPasswordVisible ? "text" : "password"}
                className="form-control"
                id="currentPassword"
                name="currentPassword"
                value={formData.currentPassword}
                // onChange={handleInputChange}
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    currentPassword: ev.target.value,
                  });
                }}
                required
              />
              <span
                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                style={{
                  cursor: "pointer",
                  marginLeft: "-30px",
                }}
              >
                {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}{" "}
              </span>
            </div>
            {errors.currentPassword && (
              <div className="text-danger">{errors.currentPassword}</div>
            )}
          </div>
          <div className="form-group mb-3 position-relative">
            <label htmlFor="newPassword" className="form-label fw-bold">
              New Password
            </label>
            <div className="d-flex  align-items-center">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                id="newPassword"
                name="newPassword"
                value={formData.newPassword}
                // onChange={handleInputChange}
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    newPassword: ev.target.value,
                  });
                }}
                required
                minLength="8"
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  cursor: "pointer",
                  marginLeft: "-30px",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
              </span>
            </div>
            {errors.newPassword && (
              <div className="text-danger">{errors.newPassword}</div>
            )}
          </div>
          <div className="form-group mb-3 position-relative">
            <label htmlFor="confirmPassword" className="form-label fw-bold">
              Confirm New Password
            </label>
            <div className="d-flex  align-items-center">
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="form-control"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                // onChange={handleInputChange}
                onChange={(ev) => {
                  setFormData({
                    ...formData,
                    confirmPassword: ev.target.value,
                  });
                }}
                required
                minLength="8" // Optional minimum password length
              />
              <span
                onClick={() => setConfirmShowPassword(!showConfirmPassword)}
                style={{
                  cursor: "pointer",
                  marginLeft: "-30px",
                }}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}{" "}
              </span>
            </div>
            {errors.confirmpassword && (
              <div className="text-danger">{errors.confirmpassword}</div>
            )}
          </div>
          {/* <div className="form-group mb-3 position-relative d-flex align-item-center gap-2">
            <input
              type="checkbox"
              className="form-check-input"
              id="showPasswordCheckbox"
              checked={isPasswordVisible}
              onChange={handleCheckboxChange}
            />
            <label className="form-check-label" htmlFor="showPasswordCheckbox">
              Show Password
            </label>
          </div> */}
          {/* {!formData.confirmPassword ||
            (!validatePasswordConfirm() && (
              <div className="invalid-feedback d-block">
                Passwords do not match
              </div>
            ))} */}
          <div className="d-flex justify-content-between">
            <button type="submit" className="btn btn-primary2">
              Save Password
            </button>
            <button className="btn btn-primary2" onClick={resetFormData}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default AccountSecurity;
